import FiniquitoMdl from '@/models/HumanResource/HRFiniquito'
export default async (finiquitoId, data) => {
    try {
        let finiquito = await FiniquitoMdl.find(finiquitoId)
        finiquito.hr_employee_id = data.hr_employee_id
        finiquito.end_date = data.end_date
        finiquito.notice_date = data.notice_date
        finiquito.payment_date = data.payment_date
        finiquito.hr_causal_id = data.hr_causal_id
        finiquito.agreed_compensation_days = data.agreed_compensation_days
        finiquito.freedays_proportional_days = data.freedays_proportional_days
        finiquito.freedays_proportional_festive_days = data.freedays_proportional_festive_days
        let response = await finiquito.save()
        return response
    } catch (error) {
        return error.response.data
    }
}